module.exports = __webpack_public_path__ + "img/dianchi-100.e1b50d43.png";